import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterService } from "../../../services/filter.service";
import { AuthService } from "../../../services/auth.service";
import { FilterRecordService } from "../../../services/filter-record.service";
import { PatientSearch } from "../../../model/patient/patient-search";
import { MedicalServiceService } from "../../../services/medical-service.service";
import { MedicalServiceSearchItem } from "../../../model/medical-service-search-item";
import { EquipmentFilter } from "../../../model/equipment-filter";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { CenterFilter } from "../../../model/center-filter";

@Component({
  selector: "app-medical-service-filter",
  templateUrl: "./medical-service-filter.component.html",
  styleUrls: ["./medical-service-filter.component.css"],
})
export class MedicalServiceFilterComponent implements IFilterComponent, OnInit {
  viewMyStudies: boolean;
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  equipmentFilters: EquipmentFilter[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private authService: AuthService,
    private medicalServiceService: MedicalServiceService,
    private notificationToastService: NotificationToastService,
    private filterRecordService: FilterRecordService
  ) {
    this.viewMyStudies = false;

    this.form = this.formBuilder.group({
      Date: [new Date()],
      ViewAttended: [false],
      ViewMyStudies: [false],
      Patient: [null],
      Center: [null],
      Equipments: [""],
    });

    this.viewMyStudies = this.authService.seeAllStudies();
    if (this.viewMyStudies) {
      this.form.patchValue({ ViewMyStudies: true });
    }

    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      [],
      this.form.controls.Center
    );
  }

  get f() {
    return this.form.controls;
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "MedicalServiceFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "MedicalServiceFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    if (!this.form.controls.Patient.value && !this.form.controls.Date.value) {
      this.notificationToastService.error(
        "Debe ingresar la fecha",
        "Atención paciente"
      );
      return null;
    } else {
      let physicianId: number;
      if (this.authService.getPhysicianId()) {
        physicianId = Number(this.authService.getPhysicianId());
      }
      const equipmentIds: number[] = [];

      if (
        this.form.controls.Equipments.value &&
        this.form.controls.Equipments.value.length > 0
      ) {
        this.form.controls.Equipments.value.forEach((element) => {
          equipmentIds.push(element.Id);
        });
      }

      return await this.medicalServiceService.getMedicalServiceSearchItem(
        <boolean>this.form.controls.ViewAttended.value,
        <boolean>this.form.controls.ViewMyStudies.value,
        equipmentIds,
        physicianId > 0 ? physicianId : null,
        this.form.controls.Date.value
          ? <Date>this.form.controls.Date.value
          : null,
        this.form.controls.Patient.value
          ? (<PatientSearch>this.form.controls.Patient.value).Id
          : null,
        this.form.controls.Center.value != null
          ? this.form.controls.Center.value.Id
          : null
      );
    }
  }

  async ngOnInit() {
    let physicianId: number = 0;
    if (this.authService.getPhysicianId()) {
      physicianId = Number(this.authService.getPhysicianId());
    }

    if (physicianId == 0) {
      this.filterService.getEquipmentsFilter().then((equipments) => {
        this.equipmentFilters = equipments;
      });
    } else {
      this.filterService
        .getEquipmentFilterByPhysician(physicianId)
        .then((equipments) => {
          this.equipmentFilters = equipments;
        });
    }

    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
        centers,
        this.form.controls.Center
      );
    });
  }
}
